import React from 'react'
import { Route, Switch } from 'react-router-dom'
import SubNavigation from '../modules/SubNavigation'
import MyDetails from '../modules/MyDetails'
import globals from '../globals'
import FormSuccess from '../components/FormSuccess'
import ChangeLogin from '../modules/ChangeLogin'
import AuthorisedContact from '../modules/AuthorisedContact'
import store from '../store'
import { connect } from 'react-redux'

class MyAccount extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            showSuccess: false
        }

        this.subNav = [
            { title: 'Update my details', url: '' },
            { title: 'Change My Exetel password', url: '/change-login' },
            { title: 'Manage authorised contact', url: '/authorised-contact' }
        ]
    }

    componentDidMount () {
        globals.animatePageIn(this.container)
    }

    handleVerificationSuccess () {
        this.setState({ showSuccess: true })
        setTimeout(() => {
            this.setState({ showSuccess: false })
        }, 5000)
    }

    render () {
        const SuccessMsg = <FormSuccess icon={false} message='Success! You can now edit your details above.' />

        const RenderMyDetails = () => {
            return (
                <MyDetails
                    isVerified={this.props.isVerified}
                    handleVerificationSuccess={this.handleVerificationSuccess.bind(this)}
                >{this.state.showSuccess ? SuccessMsg : ''}
                </MyDetails>
            )
        }

        const RenderChangeLogin = () => {
            return (
                <ChangeLogin
                    isVerified={this.props.isVerified}
                    handleVerificationSuccess={this.handleVerificationSuccess.bind(this)}
                >{this.state.showSuccess ? SuccessMsg : ''}
                </ChangeLogin>
            )
        }

        const RenderAuthorisedContact = () => {
            return (
                <AuthorisedContact
                    isVerified={this.props.isVerified}
                    handleVerificationSuccess={this.handleVerificationSuccess.bind(this)}
                >{this.state.showSuccess ? SuccessMsg : ''}
                </AuthorisedContact>
            )
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <SubNavigation
                    title='Manage my account'
                    items={this.subNav}
                    url={this.props.match.url}
                    className='gtm-payments-manage-tab-click'
                />

                <Switch>
                    <Route exact path={this.props.match.url} render={RenderMyDetails} />
                    <Route exact path={`${this.props.match.url}/change-login`} render={RenderChangeLogin} />
                    <Route exact path={`${this.props.match.url}/authorised-contact`} render={RenderAuthorisedContact} />
                </Switch>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isVerified: state.verifiedUser.isVerified,
    verifiedToken: state.verifiedUser.verifiedToken
})

export default connect(mapStateToProps)(MyAccount)



// WEBPACK FOOTER //
// ./resources/js/pages/MyAccount.js